import React from "react";
import { observer, inject } from "mobx-react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import { Label } from "react-bootstrap";

@injectIntl
@inject("rootStore")
@observer
export default class SelectableLabel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.canToggleLabel = props.rootStore.authorizationStore.canToggleLabel(
      props.note
    );
  }

  render() {
    const { label, note, intl } = this.props;

    return (
      <div
        className="note-selectable-label-container"
        onClick={this.handleClick}
      >
        <Label
          className="note-selectable-label"
          style={{ backgroundColor: label.color }}
        >
          {label.name}
        </Label>
        {note.isActiveLabel(label) && (
          <i className="fa fa-check note-selectable-icon" />
        )}
      </div>
    );
  }

  handleClick = () => {
    const { label, note, intl } = this.props;

    if (!this.canToggleLabel) {
      return;
    }

    const cardLabel = note.getCardsLabel(label);

    if (cardLabel) {
      note.updateCardsLabel(cardLabel);
    } else {
      note.addCardsLabel(label);
    }
  };

  // canToggle = (note) => {
  //         if (typeof this.canToggleNote === 'undefined') {
  //             return this.canToggleNote = CAN_TOGGLE_LABEL(note.laneStore.rootStore, note);
  //         } else {
  //             return this.canToggleNote;
  //         }
  // };
}

SelectableLabel.propTypes = {
  label: PropTypes.object.isRequired,
  note: PropTypes.object.isRequired
};
